// Native blocking: menu item to block/unblock a user
import React, { useCallback } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import { useBlockedUsers } from '../../../../graphdebate/src/hooks/useBlockedUsers';
import { IconBan } from '../../components/icons/Icons';
import { ThreadOptionsStructure } from './ThreadOptionStructure';

const messages = defineMessages({
  blockUser: {
    id: 'vdAg+H',
    defaultMessage: 'Block this user',
  },
  unblockUser: {
    id: 'cotg7u',
    defaultMessage: 'Unblock this user',
  },
});

type BlockUserMenuItemProps = {
  userId: string;
  pseudo?: string;
  picture?: string;
  className?: string;
};

export const BlockUserMenuItem: React.FC<BlockUserMenuItemProps> = ({
  userId,
  pseudo,
  picture,
}) => {
  const { isBlocked, block, unblock } = useBlockedUsers();
  const blocked = isBlocked(userId);

  const handleToggle = useCallback(async () => {
    if (blocked) {
      await unblock(userId);
    } else {
      await block({ userId, pseudo, picture });
    }
  }, [blocked, userId, pseudo, picture, block, unblock]);

  return (
    <ThreadOptionsStructure
      title={<FormattedMessage {...(blocked ? messages.unblockUser : messages.blockUser)} />}
      subtitle={null}
      icon={<IconBan className="w-4 h-4 text-current" />}
      onClick={handleToggle}
    />
  );
};
